import React from "react";
import {connect} from 'dva';
import {framework_tool, component_tool, utils_tool} from '../../../../../tool'

import {templateConfig, reduxTemplateConfig} from './config';
import moment from "moment";
import {WizTableForm} from '../../../../common'

let {WizContainer, WizReduxTemplate, modelUtils} = framework_tool
let {WizCard, WizRow, WizCol, WizModal,WizBrowserExport} = component_tool
let {Session} = utils_tool

class ApplyPlanClass extends WizContainer {
  componentName = 'applyPlanClass'

  constructor(props) {
    super(props)
    const {history} = props
    let applyInfo = {};
    if (history.location && history.location.pathname === '/workflow/apply/applyPlanClass') {
      if (history.location && history.location.record) {
        applyInfo = history.location.record
        Session.set('applyInfo', applyInfo)
      } else {
        applyInfo = Session.get('applyInfo') || {}
      }
    }
    this.applyInfo = applyInfo
    this.filters = {}
    this.state = {
      applyId: applyInfo.id,
      addApplyPlanVisible: false
    }
  }

  _componentWillMount() {
    let {applyId} = this.state
    if(!applyId) {
      this.setState({applyId: this.applyInfo.applyId})
      applyId = this.applyInfo.applyId
    }
    this._getApplyPlanInfo(applyId);
  }

  _getApplyPlanInfo(applyId) {
    this.doAction(
      {
        path: 'apply/getApplyInfo',
        payload: {
          key: 'getApplyInfo',
          apiParams: {id: applyId}
        }
      }
    )
  }

  propsAndStateOnChange = {
    createPlans: this._createPlansOnChange.bind(this),
    applyInfo: this._getApplyPlanListOver.bind(this),
  }

  _getApplyPlanListOver(nextProps, nextState) {
    if (nextProps.applyInfo.code === 1) {
      this.applyInfo = nextProps.applyInfo.data
      return true;
    } else {
      wizNotice.error(nextProps.applyInfo.msg)
      return false;
    }
  }

  _createPlansOnChange(nextProps, nextState) {
    if (nextProps.createPlans.code === 1) {
      nextState.addApplyPlanVisible=false
      nextState.addPlanKey=new Date().getTime()
      wizNotice.success(nextProps.createPlans['msg'])
      return true;
    } else {
      wizNotice.error(nextProps.createPlans['msg'])
      return false;
    }
  }

  _handleCMD(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
      wizNotice.success(o['msg'])
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _handleFile(nextProps, nextState, key) {
    let o = nextProps[key]
    let columnDefs = [
      {
        headerName: '',
        width: 30,
        field: 'rowIndex',
        hidden: true,
        suppressMovable: true,
        cellStyle: {
          textAlign: 'center',
          padding: '5px 0',
          color: '#595959',
          backgroundColor: '#f0f0f0',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: '500',
          boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
        },
      },
      {
        headerName: '学员姓名',
        field: 'fullName',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left'  },
        },
      },
      {
        headerName: '账号',
        field: 'userName',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left'  },
        },
      },
      {
        headerName: '手机号',
        field: 'mobile',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left'  },
        },
      },
      {
        headerName: '邮箱',
        field: 'email',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left'  },
        },
      },
      {
        headerName: '成绩',
        field: 'scoreStr',
        width: 10,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left'  },
        },
      },
      {
        headerName: '通过状态',
        field: 'statusStr',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left'  },
        },
      },
      {
        headerName: '评语',
        field: 'comment',
        width: 45,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left'  },
        },
      },
      {
        headerName: '是否请假',
        field: 'leaveStateStr',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left'  },
        },
      },
      {
        headerName: '班级名称',
        field: 'classInfoName',
        width: 30,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left'  },
        },
      },
      {
        headerName: '计划安排名称',
        field: 'planName',
        width: 30,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left'  },
        },
      },
      {
        headerName: '计划安排时间',
        field: 'planTime',
        width: 35,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left'  },
        },
      },
      {
        headerName: '所属课程',
        field: 'programName',
        width: 30,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left'  },
        },
      },
      {
        headerName: '课程分类',
        field: 'programCategoryNames',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left'  },
        },
      },
      {
        headerName: '地址',
        field: 'address',
        width: 30,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left'  },
        },
      },
      {
        headerName: '教室',
        field: 'siteName',
        width: 30,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left'  },
        },
      },
      {
        headerName: '培训中心',
        field: 'trainCenterName',
        width: 30,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left'  },
        },
      }
    ]
    if (o['success']) {
      let data = o['data']
      data && data.length && data.forEach(d => {
        d['planTime'] = moment(d['planStartTime']).format("YYYY-MM-DD HH:mm") + " ~ " + moment(d['planEndTime']).format("YYYY-MM-DD HH:mm")
      })
      WizBrowserExport({
        title: '学员成绩',
        sheetName: '学员成绩',
        columns: columnDefs.filter((_, index) => index),
        rows: data,
        filename: '学员成绩.xlsx',
      })
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  returnTime = (startTime, endTime) => {
    return moment(startTime).format("YYYY-MM-DD HH:mm") + " ~ " + moment(endTime).format("YYYY-MM-DD HH:mm")
  }

  returnApplyInfo = () => {
    const returnTime = this.returnTime
    let applyStatus = "";
    let applyStatusColor = {marginLeft: 20, padding: '0 5px', color: '#FFFFFF', backgroundColor: '#BEBEBE'};
    switch (this.applyInfo.status) {
      case 1:
        applyStatus = "已发布";
        applyStatusColor = {marginLeft: 20, padding: '0 5px', color: '#008B00', backgroundColor: '#B4EEB4'};
        break;
      case 2:
        applyStatus = "已取消";
        break;
      case 3:
        applyStatus = "已关闭";
        break;
      default:
        applyStatus = "草稿";
        break;
    }
    let enrollWay = "";
    switch (this.applyInfo.enrollWay) {
      case 0:
        enrollWay = "协调员报名";
        break;
      case 1:
        enrollWay = "学员报名";
        break;
    }
    let planType = "";
    switch (this.applyInfo.planType) {
      case 0:
        planType = "通用";
        break;
      case 1:
        planType = "班级";
        break;
      // case 2:
      //   planType = "活动";
      //   break;
    }
    let infoType = "";
    switch (this.applyInfo.infoType) {
      case 0:
        infoType = "无";
        break;
      case 1:
        infoType = "文字信息";
        break;
      case 2:
        infoType = "问卷收集";
        break;
    }

    const arr = [
      {label: '报名名称：', value: this.applyInfo.name},
      {label: '报名时间：', value: returnTime(this.applyInfo.startTime, this.applyInfo.endTime)},
      {label: '报名方式：', value: enrollWay},
      {label: '安排类型：', value: planType},
      {label: '信息收集：', value: infoType}
    ]

    return arr.map((val, index) => {
      return (
        <WizRow key={val.label} type="flex" gutter={[5, 16]}>
          <WizCol span={5} md={3} xs={8} style={{textAlign: 'right'}}>{val.label}</WizCol>
          {index ?
            <WizCol span={19} md={21} xs={16}>
              <div className='applyRecordInfo-discriptions'>{val.value}</div>
            </WizCol>
            :
            <WizCol span={19} md={21} xs={16}>
              {val.value}
              <span style={applyStatusColor}>{applyStatus}</span>
            </WizCol>
          }
        </WizRow>
      )
    })
  }

  _createPlans(values) {
    if (values && values.length && values.length > 0) {
      values && values.length && values.forEach(plan => {
        plan['startTime'] = moment(plan['startTime']).format("YYYY-MM-DD HH:mm:00")
        plan['endTime'] = moment(plan['endTime']).format("YYYY-MM-DD HH:mm:59")
      })
      this.doAction({
        path: 'apply/createApplyPlans',
        payload: {
          key: "createApplyPlans",
          apiParams: {applyId: this.state.applyId, plans: values}
        }
      })
    } else {
      wizNotice.error("计划安排不能为空");
      return false;
    }
  }

  _addApplyPlanSubmit = (values) => {
    let {addApplyPlanVisible} = this.state
    let plans = []
    if (addApplyPlanVisible) {
      if(values && values['valueRows']) {
        values['valueRows'].forEach(data => {
          if (data && data['id']) {
            let vars = {};
            vars['entityId'] = data['id']
            vars['name'] = data['name']
            vars['type'] = 1
            vars['startTime'] = data['startDate']
            vars['endTime'] = data['endDate']
            vars['address'] = data['address']
            vars['limitCount'] = data['limitNum']
            vars['state'] = 1
            plans.push(vars)
          }
        })
        if (plans && plans.length && plans.length > 0) {
          this._createPlans(plans)
          this.setState({addApplyPlanVisible: false})
          // location.reload();
        }
      }
    }
  }

  _onCancelApplyPlan = () => {
    this.setState({addApplyPlanVisible: false})
  }

  _render() {
    let { addApplyPlanVisible,addPlanKey } = this.state
    let _templateConfig = templateConfig({
        applyId: this.state.applyId,
        self: this,
        _addPlanBtn: (e) => {
          this.setState({addApplyPlanVisible: true})
        },
    })
    let _reduxTemplateConfig = reduxTemplateConfig({
      templateConfig: _templateConfig,
      apiDataFormat: {
        enable: this._handleCMD,
        add: this._handleCMD,
        update: this._handleCMD,
        delete: this._handleCMD,
        syncUpdatePlan: this._handleCMD,
        exportStudentGrades: this._handleFile,
      },
      applyId: this.state.applyId,
    });

    let tableFormProps = {
      title: '选择计划安排',
      showModal: true,
      visible: addApplyPlanVisible,
      selectType: 'checkbox',
      initRows: [],
      value: [],
      onSubmit: this._addApplyPlanSubmit,
      onCancel: this._onCancelApplyPlan,
      destroyOnClose: true,
      searchProps: {
        dataFormat: (v) => {
          let value = Object.assign([], v)
          if (value['classDate'] && value['classDate'].length === 2) {
            value['startDate'] = moment(value['classDate'][0]).format("YYYY-MM-DD HH:mm:00")
            value['endDate'] = moment(value['classDate'][1]).format("YYYY-MM-DD HH:mm:59")
          }
          delete value['classDate']
          return value
        }
      },
    }
    const classInfoConfig = WizTableForm.Config.classInfo(this,{apiParams: {status: 1}})

    return (
      <React.Fragment>
        <WizCard title={'报名信息'}>
          {this.returnApplyInfo()}
        </WizCard>
        <WizCard title={'计划安排管理'}>
          <WizReduxTemplate  {..._reduxTemplateConfig} key={addPlanKey}/>
          <div style={{display: "none"}}>
          <WizTableForm key={new Date().getTime()} {...classInfoConfig} {...tableFormProps}/>
          </div>
        </WizCard>
      </React.Fragment>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  let {apply, applyPlan} = state
  const applyInfo = modelUtils.getModelEntity(apply, 'getApplyInfo');
  const planPageList = modelUtils.getModelEntity(applyPlan, 'planPageList')
  const createPlans = modelUtils.getModelEntity(apply, 'createApplyPlans');
  const load = modelUtils.getLoadingState(state, ['apply','applyPlan'])
  return {
    applyInfo,
    planPageList,
    createPlans,
    ...load
  }
};

export default connect(mapStateToProps)(ApplyPlanClass);
